import { render } from "./productGallery.vue?vue&type=template&id=0424468d"
import script from "./productGallery.vue?vue&type=script&lang=js"
export * from "./productGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__